module.exports = __webpack_public_path__ + "static/media/right_layout_image.812e0f31.svg";